import React from 'react'
import { getIcon } from './Functions';

export const ModalBox = ({ children, title, buttonId, modalId, size="", className="" }) => {
    const modal = React.useRef(null);

    React.useEffect(() => {
        const btn = document.getElementById(buttonId)
        if(btn){
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                if(modal.current.classList.contains("is-active")){
                    modal.current.classList.remove("is-active")
                }else{
                    modal.current.classList.add("is-active")
                }
            })
        }
    }, [])

    return (
        <div id={modalId} ref={modal} className={`modal ${size} ${className}`}>
    <div className="modal-background modal-dismiss" />
    <div className="modal-content">
      {/*Modal card*/}
      <div className="card">
        <header className="card-header">
          <div className="card-header-title">
            <span>{title}</span>
          </div>
          <button className="modal-dismiss" onClick={() => {
              modal.current.classList.remove("is-active")
          }}>
            <span className="icon">
              <i dangerouslySetInnerHTML={{ __html: getIcon("x") }} />
            </span>
          </button>
        </header>
        <div className="card-content">
          {children}
        </div>
      </div>
    </div>
  </div>
    )
}
